import * as tslib_1 from "tslib";
// See https://github.com/MithrilJS/mithril.js/issues/2148#issuecomment-452023800
import m from 'mithril';
import { View } from './view';
export var createContext = function (context) { return ({
    Provider: /** @class */ (function (_super) {
        tslib_1.__extends(Provider, _super);
        function Provider() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Provider.prototype.render = function () {
            var received = context;
            var _a = this.attrs, value = _a.value, children = _a.children;
            context = value;
            return [
                children,
                m({
                    view: function () {
                        context = received;
                    }
                })
            ];
        };
        return Provider;
    }(View)),
    Consumer: /** @class */ (function (_super) {
        tslib_1.__extends(Consumer, _super);
        function Consumer() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Consumer.prototype.render = function () {
            var children = this.attrs.children;
            return children(context);
        };
        return Consumer;
    }(View)),
    __get: function () { return context; }
}); };
